import { skipToken } from '@reduxjs/toolkit/query';
import { Alert, Box, Button, Card, CardContent, CircularProgress, Typography } from '@shared/ui';
import AppointmentCard from '../appointments/AppointmentCard';
import {
  useGetAdminAppointmentReviewQueueQuery,
  useGetAdminAppointmentsQuery,
} from './api/adminAppointmentsApi';

interface AdminAppointmentsPageProps {
  reviewOnly?: boolean;
}

export function AdminAppointmentsPage({ reviewOnly = false }: AdminAppointmentsPageProps) {
  const listQuery = useGetAdminAppointmentsQuery(reviewOnly ? skipToken : { limit: 50 });
  const reviewQuery = useGetAdminAppointmentReviewQueueQuery(
    reviewOnly ? { reason: 'ambiguous_provider_rewrite', limit: 50 } : skipToken
  );
  const query = reviewOnly ? reviewQuery : listQuery;

  if (query.isLoading) {
    return (
      <Card>
        <CardContent>
          <CircularProgress size={20} />
        </CardContent>
      </Card>
    );
  }

  if (query.error) {
    return <Alert severity="error">Could not load appointments.</Alert>;
  }

  const appointments = query.data?.appointments ?? [];
  const title = reviewOnly ? 'Appointment review queue' : 'Appointments';

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <Typography component="h1" variant="h5">
          {title}
        </Typography>
        {!reviewOnly && (
          <Button href="/admin/appointments/review" variant="outlined">
            Review evidence
          </Button>
        )}
      </Box>
      {appointments.length === 0 ? (
        <Typography>No appointments found.</Typography>
      ) : (
        appointments.map((appointment) => (
          <AppointmentCard key={appointment.id} appointment={appointment} />
        ))
      )}
    </Box>
  );
}

export default AdminAppointmentsPage;
